import { kea } from 'kea'
import { put } from 'redux-saga/effects'
import PropTypes from 'prop-types'

import delay from 'lib/utils/delay'

import sceneLogic from '~/scenes/homepage/logic'

export default kea({
  path: () => ['scenes', 'homepage', 'how'],

  connect: {
    actions: [sceneLogic, ['showHow', 'hideHow']],
    props: [sceneLogic, ['howIsOpen', 'howItWorksLink']]
  },

  actions: () => ({
    fastHide: true,
    fastHideReset: true
  }),

  reducers: ({ actions }) => ({
    renderHow: [
      false,
      PropTypes.bool,
      {
        [actions.fastHide]: () => false,
        [actions.fastHideReset]: () => true,
        [actions.showHow]: () => true
      }
    ]
  }),

  takeEvery: ({ actions }) => ({
    * [actions.fastHide] () {
      const { hideHow, fastHideReset } = this.actions
      yield put(hideHow())
      yield delay(100)
      yield put(fastHideReset())
    }
  })
})
